"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHINESE_LOGO = void 0;
const CHINESE_LOGO = exports.CHINESE_LOGO = 'cn';